function _jade_template_fn(locals) {
  locals = locals || {};;;
  var result_of_with = (function($attr, $helpers, Array, JSON, Object, String, step) {
    var h = require("panel").h;
    var jade_mixins = {},
      $mixins = jade_mixins;
    jade_mixins['overview-copy'] = function() {
      var block = (this && this.block),
        attributes = (this && this.attributes) || {};

      return (function() {
        var __jade_nodes = [];
        __jade_nodes = __jade_nodes.concat(h("div", {
          "class": {
            'content': true
          },
        }, (function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat(h("div", {
            "class": {
              'content-container': true
            },
          }, (function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(h("h1", {
              "class": {
                'title': true
              },
            }, (function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat("Hi " + ($attr(`first-name`)) + ",");;
              return __jade_nodes
            }).call(this).filter(Boolean)));
            __jade_nodes = __jade_nodes.concat(h("h1", {
              "class": {
                'title': true
              },
            }, (function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat("welcome to Mixpanel");;
              return __jade_nodes
            }).call(this).filter(Boolean)));
            __jade_nodes = __jade_nodes.concat(h("p", {
              "class": {
                'text': true
              },
            }, (function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat("Mixpanel is a tool that helps you understand how your users interact with your app.");;
              return __jade_nodes
            }).call(this).filter(Boolean)));
            __jade_nodes = __jade_nodes.concat(h("p", {
              "class": {
                'text': true
              },
            }, (function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat("Lets spend a few minutes to walk through a couple concepts to get you started.");;
              return __jade_nodes
            }).call(this).filter(Boolean)));
            __jade_nodes = __jade_nodes.concat(h("mp-button", {
              "attrs": __vjadeStringifyAttrsIfObj({
                theme: `primary`
              }),
              "on": {
                click: $helpers.nextStep
              },
              "class": {
                'next-button': true
              },
            }, (function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat("Get Started");;
              return __jade_nodes
            }).call(this).filter(Boolean)));
            __jade_nodes = __jade_nodes.concat(($attr(`is-full-page`)) ? ((function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat(jade_mixins['skip-button'].call(this));;
              return __jade_nodes
            }).call(this)) : undefined);;
            return __jade_nodes
          }).call(this).filter(Boolean)));;
          return __jade_nodes
        }).call(this).filter(Boolean)));;
        return __jade_nodes
      }).call(this);
    };

    jade_mixins['overview-images'] = function() {
      var block = (this && this.block),
        attributes = (this && this.attributes) || {};

      return (function() {
        var __jade_nodes = [];
        __jade_nodes = __jade_nodes.concat(h("div", {
          "class": {
            'images': true
          },
        }, (function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat(h("div", {
            "class": {
              'image-container': true
            },
          }, (function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(h("div", {
              "class": {
                'ellipse-bg': true
              },
            }, (function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat(h("div", {
                "class": {
                  'shapes-fg-1': true
                },
              }, (function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat(h("img", {
                  "attrs": __vjadeStringifyAttrsIfObj({
                    src: require(`common/assets/images/onboarding-shapes.png`),
                    alt: `shapes`,
                    width: 660,
                    height: `auto`,
                    draggable: `false`,
                  }),
                  "key": "shapes1",
                }));;
                return __jade_nodes
              }).call(this).filter(Boolean)));;
              return __jade_nodes
            }).call(this).filter(Boolean)));;
            return __jade_nodes
          }).call(this).filter(Boolean)));;
          return __jade_nodes
        }).call(this).filter(Boolean)));;
        return __jade_nodes
      }).call(this);
    };

    jade_mixins['users-copy'] = function() {
      var block = (this && this.block),
        attributes = (this && this.attributes) || {};

      return (function() {
        var __jade_nodes = [];
        __jade_nodes = __jade_nodes.concat(h("div", {
          "class": {
            'content': true
          },
        }, (function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat(h("div", {
            "class": {
              'content-container': true
            },
          }, (function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(h("h1", {
              "class": {
                'title': true
              },
            }, (function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat("Every individual is a unique user");;
              return __jade_nodes
            }).call(this).filter(Boolean)));
            __jade_nodes = __jade_nodes.concat(h("p", {
              "class": {
                'text': true
              },
            }, (function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat("Imagine for a moment, you own a café.");;
              return __jade_nodes
            }).call(this).filter(Boolean)));
            __jade_nodes = __jade_nodes.concat(jade_mixins['bakery-icons'].call(this));
            __jade_nodes = __jade_nodes.concat(h("p", {
              "class": {
                'text': true
              },
            }, (function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat("Every customer who visits your cafe is unique. Details like their name, age, favorite coffee, and most recently purchased pastry are what make every customer unique.");;
              return __jade_nodes
            }).call(this).filter(Boolean)));
            __jade_nodes = __jade_nodes.concat(h("p", {
              "class": {
                'text': true
              },
            }, (function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat("In Mixpanel, these customers are called ");
              __jade_nodes = __jade_nodes.concat(h("b", {
                "class": {
                  'strong': true
                },
              }, (function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat("users");;
                return __jade_nodes
              }).call(this).filter(Boolean)));
              __jade_nodes = __jade_nodes.concat(", and their details are called ");
              __jade_nodes = __jade_nodes.concat(h("b", {
                "class": {
                  'strong': true
                },
              }, (function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat("profile properties");;
                return __jade_nodes
              }).call(this).filter(Boolean)));
              __jade_nodes = __jade_nodes.concat(". We keep track of this information to help you better understand your audience.");;
              return __jade_nodes
            }).call(this).filter(Boolean)));
            __jade_nodes = __jade_nodes.concat(jade_mixins['next-button'].call(this));
            __jade_nodes = __jade_nodes.concat(($attr(`is-full-page`)) ? ((function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat(jade_mixins['skip-button'].call(this));;
              return __jade_nodes
            }).call(this)) : undefined);;
            return __jade_nodes
          }).call(this).filter(Boolean)));;
          return __jade_nodes
        }).call(this).filter(Boolean)));;
        return __jade_nodes
      }).call(this);
    };

    jade_mixins['users-images'] = function() {
      var block = (this && this.block),
        attributes = (this && this.attributes) || {};

      return (function() {
        var __jade_nodes = [];
        __jade_nodes = __jade_nodes.concat(h("div", {
          "class": {
            'images': true
          },
        }, (function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat(h("div", {
            "class": {
              'image-container': true
            },
          }, (function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(h("div", {
              "class": {
                'ellipse-bg': true
              },
            }, (function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat(jade_mixins['profile'].call(this, {
                idx: 1,
                src: require('./images/profiles/kathy.png')
              }));
              __jade_nodes = __jade_nodes.concat(jade_mixins['profile'].call(this, {
                idx: 2,
                src: require('./images/profiles/jill.png')
              }));
              __jade_nodes = __jade_nodes.concat(jade_mixins['profile'].call(this, {
                idx: 3,
                src: require('./images/profiles/brad.png')
              }));;
              return __jade_nodes
            }).call(this).filter(Boolean)));;
            return __jade_nodes
          }).call(this).filter(Boolean)));;
          return __jade_nodes
        }).call(this).filter(Boolean)));;
        return __jade_nodes
      }).call(this);
    };

    jade_mixins['events-copy'] = function() {
      var block = (this && this.block),
        attributes = (this && this.attributes) || {};

      return (function() {
        var __jade_nodes = [];
        __jade_nodes = __jade_nodes.concat(h("div", {
          "class": {
            'content': true
          },
        }, (function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat(h("div", {
            "class": {
              'content-container': true
            },
          }, (function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(h("h1", {
              "class": {
                'title': true
              },
            }, (function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat("Any action can be tracked as an event");;
              return __jade_nodes
            }).call(this).filter(Boolean)));
            __jade_nodes = __jade_nodes.concat(h("p", {
              "class": {
                'text': true
              },
            }, (function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat("Every time a customer purchases a coffee at your café, there are details that describe the purchase the moment it happens. Details like the time of day, purchase price, and type of coffee.");;
              return __jade_nodes
            }).call(this).filter(Boolean)));
            __jade_nodes = __jade_nodes.concat(h("p", {
              "class": {
                'text': true
              },
            }, (function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat("Actions like purchasing a coffee can be tracked as an ");
              __jade_nodes = __jade_nodes.concat(h("b", {
                "class": {
                  'strong': true
                },
              }, (function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat("event ");;
                return __jade_nodes
              }).call(this).filter(Boolean)));
              __jade_nodes = __jade_nodes.concat("in Mixpanel. All of details describing the event in the moment are called ");
              __jade_nodes = __jade_nodes.concat(h("b", {
                "class": {
                  'strong': true
                },
              }, (function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat("event properties.");;
                return __jade_nodes
              }).call(this).filter(Boolean)));;
              return __jade_nodes
            }).call(this).filter(Boolean)));
            __jade_nodes = __jade_nodes.concat(jade_mixins['next-button'].call(this));
            __jade_nodes = __jade_nodes.concat(($attr(`is-full-page`)) ? ((function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat(jade_mixins['skip-button'].call(this));;
              return __jade_nodes
            }).call(this)) : undefined);;
            return __jade_nodes
          }).call(this).filter(Boolean)));;
          return __jade_nodes
        }).call(this).filter(Boolean)));;
        return __jade_nodes
      }).call(this);
    };

    jade_mixins['events-images'] = function() {
      var block = (this && this.block),
        attributes = (this && this.attributes) || {};

      return (function() {
        var __jade_nodes = [];
        __jade_nodes = __jade_nodes.concat(h("div", {
          "class": {
            'images': true
          },
        }, (function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat(h("div", {
            "class": {
              'image-container': true
            },
          }, (function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(h("div", {
              "class": {
                'ellipse-bg': true
              },
            }, (function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat(h("div", {
                "class": {
                  'event-carousel-container': true
                },
              }, (function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat(h("event-carousel"));;
                return __jade_nodes
              }).call(this).filter(Boolean)));;
              return __jade_nodes
            }).call(this).filter(Boolean)));;
            return __jade_nodes
          }).call(this).filter(Boolean)));;
          return __jade_nodes
        }).call(this).filter(Boolean)));;
        return __jade_nodes
      }).call(this);
    };

    jade_mixins['profiles-copy'] = function() {
      var block = (this && this.block),
        attributes = (this && this.attributes) || {};

      return (function() {
        var __jade_nodes = [];
        __jade_nodes = __jade_nodes.concat(h("div", {
          "class": {
            'content': true
          },
        }, (function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat(h("div", {
            "class": {
              'content-container': true
            },
          }, (function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(h("h1", {
              "class": {
                'title': true
              },
            }, (function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat("Profiles bring everything together");;
              return __jade_nodes
            }).call(this).filter(Boolean)));
            __jade_nodes = __jade_nodes.concat(h("p", {
              "class": {
                'text': true
              },
            }, (function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat("With profile properties keeping track of who a user is, and events keeping track of what a user does, Mixpanel consolidates this information into a ");
              __jade_nodes = __jade_nodes.concat(h("b", {
                "class": {
                  'strong': true
                },
              }, (function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat("profile ");;
                return __jade_nodes
              }).call(this).filter(Boolean)));
              __jade_nodes = __jade_nodes.concat("for every user.");;
              return __jade_nodes
            }).call(this).filter(Boolean)));
            __jade_nodes = __jade_nodes.concat(h("p", {
              "class": {
                'text': true
              },
            }, (function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat("Having all this customer information available allows you to uncover your café's most popular pastry or the average amount spent by each customer.");;
              return __jade_nodes
            }).call(this).filter(Boolean)));
            __jade_nodes = __jade_nodes.concat(jade_mixins['next-button'].call(this));
            __jade_nodes = __jade_nodes.concat(($attr(`is-full-page`)) ? ((function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat(jade_mixins['skip-button'].call(this));;
              return __jade_nodes
            }).call(this)) : undefined);;
            return __jade_nodes
          }).call(this).filter(Boolean)));;
          return __jade_nodes
        }).call(this).filter(Boolean)));;
        return __jade_nodes
      }).call(this);
    };

    jade_mixins['complete-copy'] = function() {
      var block = (this && this.block),
        attributes = (this && this.attributes) || {};

      return (function() {
        var __jade_nodes = [];
        __jade_nodes = __jade_nodes.concat(h("div", {
          "class": {
            'content': true
          },
        }, (function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat(h("div", {
            "class": {
              'content-container': true
            },
          }, (function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(h("h1", {
              "class": {
                'title': true
              },
            }, (function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat("Great work 🎉");;
              return __jade_nodes
            }).call(this).filter(Boolean)));
            __jade_nodes = __jade_nodes.concat(h("p", {
              "class": {
                'text': true
              },
            }, (function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat("Now that you’re familiar with all of the building blocks, you’re ready to get started in Mixpanel.");;
              return __jade_nodes
            }).call(this).filter(Boolean)));
            __jade_nodes = __jade_nodes.concat(($attr(`is-dashboards-next`)) ? ((function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat(h("p", {
                "class": {
                  'text': true,
                  'dashboards-notice': true
                },
              }, (function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat("Dashboards are the homebase for you to collaborate with your team.");;
                return __jade_nodes
              }).call(this).filter(Boolean)));;
              return __jade_nodes
            }).call(this)) : undefined);
            __jade_nodes = __jade_nodes.concat(($attr(`is-full-page`)) ? ((function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat(h("mp-button", {
                "attrs": __vjadeStringifyAttrsIfObj({
                  theme: `primary`,
                  href: $helpers.appendMpSource(`intro-complete`)
                }),
                "class": {
                  'next-button': true
                },
              }, [__vjadeSafeCode(`Go to ${$attr(`is-dashboards-next`) ? `Your Dashboard` : `Mixpanel`}`)]));;
              return __jade_nodes
            }).call(this)) : ((function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat(h("mp-button", {
                "attrs": __vjadeStringifyAttrsIfObj({
                  theme: `primary`
                }),
                "on": {
                  click: $helpers.onCloseButtonClick
                },
                "class": {
                  'next-button': true
                },
              }, (function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat("Done");;
                return __jade_nodes
              }).call(this).filter(Boolean)));;
              return __jade_nodes
            }).call(this)));;
            return __jade_nodes
          }).call(this).filter(Boolean)));;
          return __jade_nodes
        }).call(this).filter(Boolean)));;
        return __jade_nodes
      }).call(this);
    };

    jade_mixins['complete-images'] = function() {
      var block = (this && this.block),
        attributes = (this && this.attributes) || {};

      return (function() {
        var __jade_nodes = [];
        __jade_nodes = __jade_nodes.concat(h("div", {
          "class": {
            'images': true
          },
        }, (function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat(h("div", {
            "class": {
              'image-container': true
            },
          }, (function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(h("div", {
              "class": {
                'ellipse-bg': true
              },
            }, (function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat(h("div", {
                "class": {
                  'shapes-fg-2': true
                },
              }, (function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat(h("img", {
                  "attrs": __vjadeStringifyAttrsIfObj({
                    src: require(`./images/shapes2.png`),
                    alt: `shapes`,
                    width: 600,
                    height: `auto`,
                    draggable: `false`,
                  }),
                  "key": "shapes2",
                }));;
                return __jade_nodes
              }).call(this).filter(Boolean)));;
              return __jade_nodes
            }).call(this).filter(Boolean)));;
            return __jade_nodes
          }).call(this).filter(Boolean)));;
          return __jade_nodes
        }).call(this).filter(Boolean)));;
        return __jade_nodes
      }).call(this);
    };

    jade_mixins['complete-images-dashboard'] = function() {
      var block = (this && this.block),
        attributes = (this && this.attributes) || {};

      return (function() {
        var __jade_nodes = [];
        __jade_nodes = __jade_nodes.concat(h("div", {
          "class": {
            'images': true
          },
        }, (function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat(h("div", {
            "class": {
              'image-container': true
            },
          }, (function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(h("div", {
              "class": {
                'ellipse-bg': true
              },
            }, (function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat(h("div", {
                "class": {
                  'dashboard-fg': true
                },
              }, (function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat(h("img", {
                  "attrs": __vjadeStringifyAttrsIfObj({
                    src: require(`./images/my-dashboard.png`),
                    alt: `shapes`,
                    width: 800,
                    height: `auto`,
                    draggable: `false`,
                  }),
                  "key": "shapes2",
                }));;
                return __jade_nodes
              }).call(this).filter(Boolean)));;
              return __jade_nodes
            }).call(this).filter(Boolean)));;
            return __jade_nodes
          }).call(this).filter(Boolean)));;
          return __jade_nodes
        }).call(this).filter(Boolean)));;
        return __jade_nodes
      }).call(this);
    };

    jade_mixins['profile-brad-gif'] = function() {
      var block = (this && this.block),
        attributes = (this && this.attributes) || {};

      return (function() {
        var __jade_nodes = [];
        __jade_nodes = __jade_nodes.concat(h("div", {
          "class": {
            'images': true
          },
        }, (function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat(h("div", {
            "class": {
              'image-container': true
            },
          }, (function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(h("div", {
              "class": {
                'ellipse-bg': true
              },
            }, (function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat(h("div", {
                "class": {
                  'profile-animated': true
                },
              }, (function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat(h("div", {
                  "class": {
                    'profile-img': true
                  },
                }, (function() {
                  var __jade_nodes = [];
                  __jade_nodes = __jade_nodes.concat(h("img", {
                    "attrs": __vjadeStringifyAttrsIfObj({
                      src: require('./images/profiles/brad-animated.gif'),
                      alt: `brad`,
                      draggable: `false`,
                      width: 360,
                    }),
                  }));;
                  return __jade_nodes
                }).call(this).filter(Boolean)));;
                return __jade_nodes
              }).call(this).filter(Boolean)));;
              return __jade_nodes
            }).call(this).filter(Boolean)));;
            return __jade_nodes
          }).call(this).filter(Boolean)));;
          return __jade_nodes
        }).call(this).filter(Boolean)));;
        return __jade_nodes
      }).call(this);
    };

    jade_mixins['bakery-icons'] = function() {
      var block = (this && this.block),
        attributes = (this && this.attributes) || {};

      return (function() {
        var __jade_nodes = [];
        __jade_nodes = __jade_nodes.concat(h("div", {
          "class": {
            'bakery-icons': true
          },
        }, (function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat(h('div', {
            props: {
              innerHTML: '<svg width="46" height="46" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M20.128 19.596l.954-.954a2 2 0 013.162.444l4.04 7.273a2 2 0 01-.333 2.385l-5.746 5.746a2 2 0 01-2.386.334l-7.273-4.04a2 2 0 01-.443-3.163l.954-.954" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M24.017 18.535l3.491-1.314a2 2 0 012.471.934l2.03 3.823a2 2 0 01-.351 2.352l-3.045 3.044m-17.077 3.643l-1.315 3.491a2 2 0 00.934 2.471l3.823 2.03a2 2 0 002.352-.351l3.044-3.045" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M31.017 17.745l1.42-.449a2.886 2.886 0 013.679 2.094v0a1.443 1.443 0 01-.684 1.579l-3.22 1.86M10.745 38.016l-.449 1.42a2.886 2.886 0 002.094 3.679v0a1.443 1.443 0 001.579-.684l1.86-3.22M14.29 26.44a2 2 0 01-.595-3.239l2.966-2.966a2 2 0 013.24.596l2.11 4.706a2.28 2.28 0 01-.469 2.545v0a2.28 2.28 0 01-2.545.468l-4.706-2.11z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>'
            }
          }));
          __jade_nodes = __jade_nodes.concat(h('div', {
            props: {
              innerHTML: '<svg width="46" height="46" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12 28h18v7a9 9 0 01-9 9v0a9 9 0 01-9-9v-7zm1 4h12M12 44h18m0-16h1.757a3.243 3.243 0 110 6.486H30M19 20c1.165.582 2 2.153 2 4m-2-4c-1.165-.582-2-2.153-2-4m6 2c-1.165-.582-2-2.153-2-4" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>'
            }
          }));
          __jade_nodes = __jade_nodes.concat(h('div', {
            props: {
              innerHTML: '<svg width="46" height="46" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="23" cy="30" r="14" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><circle cx="23" cy="30" r="4" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M30.944 26.712c.7-3.183-1.468-5.352-4.65-4.652-1.747-2.746-4.823-2.746-6.571 0-3.181-.7-5.349 1.469-4.65 4.652-2.761 1.749-2.761 4.827-.017 6.576-.7 3.183 1.468 5.352 4.65 4.653 1.747 2.745 4.823 2.745 6.571 0 3.181.7 5.349-1.47 4.65-4.653 2.761-1.749 2.761-4.827.017-6.576z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>'
            }
          }));
          __jade_nodes = __jade_nodes.concat(h('div', {
            props: {
              innerHTML: '<svg width="46" height="46" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M14 18h18l-2.77 26H16.77L14 18zm12 21.5l1.158-11m.737-7l.369-3.5M29 11l-.737 7" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><rect x="20" y="34" width="6" height="6" rx="1" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><rect x="23" y="22" width="6" height="6" rx="1" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><rect x="20" y="25.757" width="6" height="6" rx="1" transform="rotate(45 20 25.757)" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>'
            }
          }));
          __jade_nodes = __jade_nodes.concat(h('div', {
            props: {
              innerHTML: '<svg width="46" height="46" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12 14h22v4H12v-4zm3-3h16v3H15v-3zm-2 14h20l-1.429 10H14.43L13 25zm3.77 19h12.46l1.27-9h-15l1.27 9zM32 18H14l.746 7h16.508L32 18zM14 29h7.5M23 7c-1.165-.582-2-2.153-2-4" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>'
            }
          }));;
          return __jade_nodes
        }).call(this).filter(Boolean)));;
        return __jade_nodes
      }).call(this);
    };

    jade_mixins['profile'] = function({
      idx,
      src
    }) {
      var block = (this && this.block),
        attributes = (this && this.attributes) || {};

      return (function() {
        var __jade_nodes = [];
        __jade_nodes = __jade_nodes.concat(h("div", {
          "key": `profile${idx}`,
          "class": Object.assign({}, {
            [`profile-fg-${idx}`]: true,
          }, {
            'profile': true
          }),
        }, (function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat(h("div", {
            "class": {
              'profile-img': true
            },
          }, (function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(h("img", {
              "attrs": __vjadeStringifyAttrsIfObj({
                src,
                alt: `user`,
                draggable: `false`,
                width: 360
              }),
            }));;
            return __jade_nodes
          }).call(this).filter(Boolean)));;
          return __jade_nodes
        }).call(this).filter(Boolean)));;
        return __jade_nodes
      }).call(this);
    };

    jade_mixins['skip-button'] = function() {
      var block = (this && this.block),
        attributes = (this && this.attributes) || {};

      return (function() {
        var __jade_nodes = [];
        __jade_nodes = __jade_nodes.concat(h("mp-button", {
          "attrs": __vjadeStringifyAttrsIfObj({
            theme: `tertiary`,
            href: $helpers.appendMpSource(`intro-skip`),
          }),
          "class": {
            'skip-button': true
          },
        }, (function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat("Skip");;
          return __jade_nodes
        }).call(this).filter(Boolean)));;
        return __jade_nodes
      }).call(this);
    };

    jade_mixins['next-button'] = function() {
      var block = (this && this.block),
        attributes = (this && this.attributes) || {};

      return (function() {
        var __jade_nodes = [];
        __jade_nodes = __jade_nodes.concat(h("mp-button", {
          "attrs": __vjadeStringifyAttrsIfObj({
            theme: `primary`
          }),
          "on": {
            click: $helpers.nextStep
          },
          "class": {
            'next-button': true
          },
        }, (function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat("Next →");;
          return __jade_nodes
        }).call(this).filter(Boolean)));;
        return __jade_nodes
      }).call(this);
    };

    jade_mixins['step-button'] = function(index, {
      name,
      text,
      icon,
      active,
      visited
    }) {
      var block = (this && this.block),
        attributes = (this && this.attributes) || {};

      return (function() {
        var __jade_nodes = [];
        __jade_nodes = __jade_nodes.concat(h("div", {
          "on": {
            click: () => $helpers.handleStepClick(index)
          },
          "class": Object.assign({}, {
            active,
            visited,
            [name]: true
          }, {
            'step-button': true
          }),
        }, (function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat(h("div", {
            "class": {
              'step-button-content': true
            },
          }, (function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(h("svg-icon", {
              "attrs": __vjadeStringifyAttrsIfObj({
                icon
              }),
            }));
            __jade_nodes = __jade_nodes.concat(h("div", {
              "class": {
                'step-button-label': true
              },
            }, [__vjadeSafeCode(text)]));;
            return __jade_nodes
          }).call(this).filter(Boolean)));
          __jade_nodes = __jade_nodes.concat(h("div", {
            "class": {
              'step-button-indicator': true
            },
          }, (function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat((visited) ? ((function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat(h("svg-icon", {
                "attrs": __vjadeStringifyAttrsIfObj({
                  icon: `circle-checkmark`
                }),
              }));;
              return __jade_nodes
            }).call(this)) : ((function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat(h("div", {
                "class": {
                  'step-button-index': true
                },
              }, [__vjadeSafeCode(index + 1)]));;
              return __jade_nodes
            }).call(this)));;
            return __jade_nodes
          }).call(this).filter(Boolean)));;
          return __jade_nodes
        }).call(this).filter(Boolean)));;
        return __jade_nodes
      }).call(this);
    };

    var __vjadeStringifyAttrsIfObj = function(attrs) {
      if (typeof attrs !== 'object') return attrs;
      const copy = {};
      for (const [k, v] of Object.entries(attrs)) {
        copy[k] = typeof attrs[k] === 'object' ? JSON.stringify(v) : v;
      }
      return copy;
    }

    var __vjadeSafeCode = function(code) {
      return code || String(code);
    };
    const steps = $helpers.getIntroSteps();;
    const buttonSteps = steps.slice(0, -1);;
    return {
      value: (h("div", {
        "class": {
          'intro-page': true
        },
      }, (function() {
        var __jade_nodes = [];
        __jade_nodes = __jade_nodes.concat(h("div", {
          "class": Object.assign({}, {
            'is-full-page': $attr(`is-full-page`)
          }, {
            'intro-container': true
          }),
        }, (function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat(h("div", {
            "class": {
              'header': true
            },
          }, (function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(h("a", {
              "attrs": __vjadeStringifyAttrsIfObj({
                href: '/'
              }),
              "class": {
                'logo': true
              },
            }, (function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat(h('div', {
                props: {
                  innerHTML: '<?xml version="1.0" encoding="UTF-8"?><svg viewBox="0 0 144 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">    <title>Mixpanel logo</title>    <g id="Final-Variant" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">        <g id="500-template-final" transform="translate(-60.000000, -138.000000)" fill="currentColor">            <g transform="translate(60.000000, 138.233333)">                <path d="M12.48961,40.9223504 C12.48961,44.4051408 9.69368013,47.2280341 6.24480502,47.2280341 C2.79592991,47.2280341 6.297185e-13,44.4051408 6.297185e-13,40.9223504 C6.297185e-13,37.43956 2.79592991,34.6166667 6.24480502,34.6166667 C9.69368013,34.6166667 12.48961,37.43956 12.48961,40.9223504" id="Fill-1-Copy"></path>                <path d="M33.2786651,41.3100248 C33.2786651,43.7730541 31.3012404,45.7700495 28.8617,45.7700495 C26.4221597,45.7700495 24.4444444,43.7730541 24.4444444,41.3100248 C24.4444444,38.8467021 26.4221597,36.85 28.8617,36.85 C31.3012404,36.85 33.2786651,38.8467021 33.2786651,41.3100248" id="Fill-4-Copy"></path>                <path d="M49.5661727,41.1084843 C49.5661727,42.22679 48.668373,43.133342 47.5608641,43.133342 C46.4533552,43.133342 45.5555556,42.22679 45.5555556,41.1084843 C45.5555556,39.9901786 46.4533552,39.0833333 47.5608641,39.0833333 C48.668373,39.0833333 49.5661727,39.9901786 49.5661727,41.1084843" id="Fill-5-Copy"></path>                <path d="M27.9360626,28.6913608 C26.8378483,28.6913608 26.0248619,27.8288019 26.0248619,26.761235 L26.0248619,18.5491818 C26.0248619,15.7160234 24.6829549,13.5398293 21.6738303,13.5398293 C18.6647056,13.5398293 16.8348325,15.8805578 16.8348325,18.5902421 L16.8348325,26.761235 C16.8348325,27.8288019 16.1028833,28.6913608 14.9236317,28.6913608 C13.785044,28.6913608 13.0124309,27.8288019 13.0124309,26.761235 L13.0124309,18.5491818 C13.0124309,15.7160234 11.5485324,13.5398293 8.5394078,13.5398293 C5.44895545,13.5398293 3.82240158,15.8805578 3.82240158,18.5902421 L3.82240158,26.761235 C3.82240158,27.8288019 3.0497885,28.6913608 1.91120079,28.6913608 C0.813276933,28.6913608 -3.05533376e-13,27.8288019 -3.05533376e-13,26.761235 L-3.05533376e-13,12.1848405 C-3.05533376e-13,11.0351531 0.73194924,10.2139478 1.91120079,10.2139478 C3.21244389,10.2139478 3.82240158,11.1175669 3.82240158,12.1848405 L3.82240158,13.4990624 C4.92032544,11.3228682 7.15683701,10.05 9.55600396,10.05 C12.4838009,10.05 14.6796486,11.5281696 15.7775725,13.7043637 C17.3634625,11.2407477 19.6813018,10.05 22.5684349,10.05 C27.4887603,10.05 29.846973,13.4580021 29.846973,18.2620532 L29.846973,26.761235 C29.846973,27.8288019 29.0746504,28.6913608 27.9360626,28.6913608" id="Fill-7-Copy"></path>                <path d="M35.5698449,28.0191804 C34.4312572,28.0191804 33.6586441,27.1566216 33.6586441,26.0890546 L33.6586441,11.4718932 C33.6586441,10.4043263 34.4716306,9.54176741 35.5698449,9.54176741 C36.6677688,9.54176741 37.4807552,10.4043263 37.4807552,11.4718932 L37.4807552,26.0890546 C37.4807552,27.1566216 36.7084326,28.0191804 35.5698449,28.0191804 Z M35.5698449,2.23333333 C36.7894698,2.23333333 37.806066,3.25983999 37.806066,4.49164797 C37.806066,5.72345595 36.7894698,6.7499626 35.5698449,6.7499626 C34.3499295,6.7499626 33.3333333,5.72345595 33.3333333,4.49164797 C33.3333333,3.25983999 34.3499295,2.23333333 35.5698449,2.23333333 L35.5698449,2.23333333 Z" id="Fill-9-Copy"></path>                <path d="M47.9294501,16.7017631 L52.7684478,10.625137 C53.0937586,10.2555946 53.5003971,10.05 54.0287366,10.05 C55.0862871,10.05 55.7775725,10.7480245 55.7775725,11.7337642 C55.7775725,12.1033066 55.655581,12.4725557 55.3302702,12.8423914 L50.0033063,19.2477929 L55.4115979,25.6939614 C55.6962448,26.0227368 55.8589002,26.3512189 55.8589002,26.8436488 C55.8589002,27.7880349 55.0453328,28.527413 54.1510186,28.527413 C53.5817248,28.527413 53.1344225,28.3218184 52.8091117,27.9112157 L47.9294501,21.7935294 L43.0497885,27.9112157 C42.7244777,28.3218184 42.2771754,28.527413 41.7078816,28.527413 C40.8132769,28.527413 40,27.7880349 40,26.8436488 C40,26.3512189 40.1626554,26.0227368 40.4473023,25.6939614 L45.8555939,19.2477929 L40.52863,12.8423914 C40.2033192,12.4725557 40.0813277,12.1033066 40.0813277,11.7337642 C40.0813277,10.7480245 40.7726131,10.05 41.8298731,10.05 C42.3585031,10.05 42.7651416,10.2555946 43.0904523,10.625137 L47.9294501,16.7017631" id="Fill-10-Copy"></path>                <path d="M68.2009098,13.2527008 C64.9071382,13.2527008 62.7112905,16.1676864 62.7112905,19.4528009 C62.7112905,22.7376222 64.9071382,25.6526078 68.2009098,25.6526078 C71.4946813,25.6526078 73.6498652,23.1479316 73.6498652,19.4528009 C73.6498652,15.757377 71.4946813,13.2527008 68.2009098,13.2527008 Z M68.9735229,28.8553086 C66.2490451,28.8553086 64.0125336,27.4184926 62.7112905,25.3241257 L62.7112905,34.4395048 C62.7112905,35.507365 61.9386774,36.3693373 60.8000897,36.3693373 C59.661502,36.3693373 58.8888889,35.507365 58.8888889,34.4395048 L58.8888889,12.1440736 C58.8888889,11.0765067 59.5395104,10.2139478 60.718762,10.2139478 C61.8980135,10.2139478 62.5892989,11.1175669 62.5892989,12.1848405 L62.5892989,13.5811829 C63.8092143,11.446049 66.2490451,10.05 68.9735229,10.05 C73.6498652,10.05 77.4722668,13.9914923 77.4722668,19.4528009 C77.4722668,25.1191177 73.6498652,28.8553086 68.9735229,28.8553086 L68.9735229,28.8553086 Z" id="Fill-11-Copy"></path>                <path d="M88.2415736,13.334528 C84.9884659,13.334528 82.7112905,16.0858591 82.7112905,19.4528009 C82.7112905,22.9839838 84.6224913,25.5707806 88.2415736,25.5707806 C91.6163824,25.5707806 93.7715663,22.6552084 93.7715663,19.4528009 C93.7715663,15.6752565 91.4946813,13.334528 88.2415736,13.334528 Z M97.5942583,26.761235 C97.5942583,27.8288019 96.8623091,28.6913608 95.6827671,28.6913608 C94.5444698,28.6913608 93.8125206,27.8288019 93.8125206,26.761235 L93.8125206,25.8579092 C92.6739329,27.5824403 90.518749,28.8553086 87.8758895,28.8553086 C82.1826605,28.8553086 78.8888889,24.6674547 78.8888889,19.4528009 C78.8888889,14.3202677 82.5486351,10.05 88.2822375,10.05 C94.1378314,10.05 97.5942583,13.909665 97.5942583,19.4528009 L97.5942583,26.761235 L97.5942583,26.761235 Z" id="Fill-12-Copy"></path>                <path d="M108.499034,10.05 C113.419069,10.05 117.037861,13.8275445 117.037861,18.6315956 L117.037861,26.761235 C117.037861,27.8288019 116.184211,28.6913608 115.12666,28.6913608 C114.069691,28.6913608 113.21546,27.8288019 113.21546,26.761235 L113.21546,18.1799327 C113.21546,15.5928426 111.182267,13.5811829 108.499034,13.5811829 C105.81493,13.5811829 103.822402,15.5928426 103.822402,18.1799327 L103.822402,26.761235 C103.822402,27.8288019 102.968461,28.6913608 101.911201,28.6913608 C100.853941,28.6913608 100,27.8288019 100,26.761235 L100,18.6315956 C100,13.8275445 103.578419,10.05 108.499034,10.05" id="Fill-13-Copy"></path>                <path d="M129.108411,13.12952 C126.302606,13.12952 124.391405,15.1411797 124.02543,17.6872095 L134.028446,17.6872095 C133.703426,15.2235935 131.873262,13.12952 129.108411,13.12952 Z M137.566201,19.4935679 C137.566201,20.1505322 137.200226,20.8077897 136.102593,20.8077897 L123.944393,20.8077897 C124.147422,23.6409481 126.058623,25.7757886 129.433432,25.7757886 C131.548242,25.7757886 132.808821,25.0369971 134.150438,23.7641289 C134.476039,23.4356467 134.923051,23.1479316 135.411017,23.1479316 C136.265539,23.1479316 136.997197,23.7641289 136.997197,24.749282 C136.997197,25.1601779 136.793588,25.529427 136.509231,25.8579092 C134.964005,27.6648541 132.199154,28.8553086 129.271067,28.8553086 C123.211863,28.8553086 120,24.5853342 120,19.4528009 C120,14.0739061 123.862485,10.05 129.108411,10.05 C134.232346,10.05 137.566201,14.2378539 137.566201,19.4935679 L137.566201,19.4935679 Z" id="Fill-14-Copy"></path>                <path d="M141.911201,28.0031015 C140.772904,28.0031015 140,27.1405426 140,26.0729757 L140,1.92983251 C140,0.8619723 140.772904,2.73558953e-13 141.911201,2.73558953e-13 C143.049788,2.73558953e-13 143.822692,0.8619723 143.822692,1.92983251 L143.822692,26.0729757 C143.822692,27.1405426 143.049788,28.0031015 141.911201,28.0031015" id="Fill-15-Copy"></path>            </g>        </g>    </g></svg>'
                }
              }));;
              return __jade_nodes
            }).call(this).filter(Boolean)));;
            return __jade_nodes
          }).call(this).filter(Boolean)));
          __jade_nodes = __jade_nodes.concat(h("div", {
            "class": {
              'steps': true
            },
          }, (function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(h("div", {
              "class": {
                'steps-container': true
              },
            }, (function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat((function() {
                var $$obj = (buttonSteps);
                var $$eachNodes;
                var $$iterated = false;
                if (Array.isArray($$obj)) {
                  $$eachNodes = $$obj.reduce(function($$eachNodes, step, idx) {
                    $$iterated = true;
                    return $$eachNodes.concat((function() {
                      var __jade_nodes = [];
                      __jade_nodes = __jade_nodes.concat(jade_mixins['step-button'].call(this, idx, step));;
                      return __jade_nodes
                    }).call(this));
                  }, []);
                } else {
                  $$eachNodes = [];
                  for (var $$objKey in $$obj) {
                    (function() {
                      var idx = $$objKey;
                      if ($$obj.hasOwnProperty(idx)) {
                        $$iterated = true;
                        var step = $$obj[idx];
                        $$eachNodes = $$eachNodes.concat((function() {
                          var __jade_nodes = [];
                          __jade_nodes = __jade_nodes.concat(jade_mixins['step-button'].call(this, idx, step));;
                          return __jade_nodes
                        }).call(this));
                      }
                    })();
                  }
                }

                return $$eachNodes;
              })());;
              return __jade_nodes
            }).call(this).filter(Boolean)));;
            return __jade_nodes
          }).call(this).filter(Boolean)));
          const currentStep = steps[step];;
          __jade_nodes = __jade_nodes.concat((((currentStep.name) == ($helpers.IntroStepName.Mixpanel))) ?
            ((function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat(jade_mixins['overview-copy'].call(this));
              __jade_nodes = __jade_nodes.concat(jade_mixins['overview-images'].call(this));;
              return __jade_nodes
            }).call(this)) :
            (((currentStep.name) == ($helpers.IntroStepName.Users))) ?
            ((function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat(jade_mixins['users-copy'].call(this));
              __jade_nodes = __jade_nodes.concat(jade_mixins['users-images'].call(this));;
              return __jade_nodes
            }).call(this)) :
            (((currentStep.name) == ($helpers.IntroStepName.Events))) ?
            ((function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat(jade_mixins['events-copy'].call(this));
              __jade_nodes = __jade_nodes.concat(jade_mixins['events-images'].call(this));;
              return __jade_nodes
            }).call(this)) :
            (((currentStep.name) == ($helpers.IntroStepName.Profiles))) ?
            ((function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat(jade_mixins['profiles-copy'].call(this));
              __jade_nodes = __jade_nodes.concat(jade_mixins['profile-brad-gif'].call(this));;
              return __jade_nodes
            }).call(this)) :
            (((currentStep.name) == ($helpers.IntroStepName.Complete))) ?
            ((function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat(jade_mixins['complete-copy'].call(this));
              __jade_nodes = __jade_nodes.concat(($attr(`is-dashboards-next`)) ? ((function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat(jade_mixins['complete-images-dashboard'].call(this));;
                return __jade_nodes
              }).call(this)) : ((function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat(jade_mixins['complete-images'].call(this));;
                return __jade_nodes
              }).call(this)));;
              return __jade_nodes
            }).call(this)) :
            undefined);;
          return __jade_nodes
        }).call(this).filter(Boolean)));;
        return __jade_nodes
      }).call(this).filter(Boolean)))
    };

  }.call(this, "$attr" in locals ? locals.$attr : typeof $attr !== "undefined" ? $attr : undefined, "$helpers" in locals ? locals.$helpers : typeof $helpers !== "undefined" ? $helpers : undefined, "Array" in locals ? locals.Array : typeof Array !== "undefined" ? Array : undefined, "JSON" in locals ? locals.JSON : typeof JSON !== "undefined" ? JSON : undefined, "Object" in locals ? locals.Object : typeof Object !== "undefined" ? Object : undefined, "String" in locals ? locals.String : typeof String !== "undefined" ? String : undefined, "step" in locals ? locals.step : typeof step !== "undefined" ? step : undefined));
  if (result_of_with) return result_of_with.value;
}
module.exports = _jade_template_fn;